import { createContext, useContext, useState, useEffect } from "react";

const PortfolioContext = createContext();

export const PortfolioProvider = ({ children }) => {
  const [companySelected, setCompanySelected] = useState(
    () => localStorage.getItem("companySelected") || 0
  );
  const [projectSelected, setProjectSelected] = useState(
    () => Number(localStorage.getItem("projectSelected")) || 0
  );

  useEffect(() => {
    localStorage.setItem("companySelected", companySelected);
  }, [companySelected]);

  useEffect(() => {
    localStorage.setItem("projectSelected", projectSelected);
  }, [projectSelected]);

  return (
    <PortfolioContext.Provider
      value={{
        companySelected,
        setCompanySelected,
        projectSelected,
        setProjectSelected,
      }}
    >
      {children}
    </PortfolioContext.Provider>
  );
};

export const useTypeOfProjectContext = () => useContext(PortfolioContext);
